// *******************************************************************************
// Login form validation
// *******************************************************************************

document.addEventListener('DOMContentLoaded', () => {
	const loginForm = document.getElementById('login-form');

	if (loginForm) {
		const axiosLoginAction = (formData) => {
			grecaptcha.ready(() => {
				grecaptcha.execute(localData.captchaSiteKey, { action: formData.action }).then((token) => {
					const formErrorMessage = loginForm.querySelector('.form-error-message');
					formErrorMessage.classList.remove('is-validation-failed');
					formErrorMessage.innerHTML = formErrorMessage.getAttribute('data-generic-error-message');
					const formDataInput = new FormData();
					formDataInput.append('action', formData.login_action);
					formDataInput.append('inputs', JSON.stringify(formData));
					formDataInput.append('lang', localData.lang);
					formDataInput.append('id', localData.id);
					formDataInput.append('token', token);
					axios
						.post(localData.siteURL, formDataInput, {
							headers: {
								'Content-Type': 'multipart/form-data',
							},
						})
						.then((response) => {
							if (response.status === 200) {
								window.location.replace(response.data.data.url);
							}
						})
						.catch((err) => {
							formErrorMessage.innerHTML = err.response.data.data.msg;
							formErrorMessage.classList.add('is-validation-failed');
							document.querySelector('body').classList.remove('is-loading');
						});
				});
			});
		};

		const fv = FormValidation.formValidation(loginForm, {
			locale: 'sl_SI',
			localization: FormValidation.locales.sl_SI,
			fields: {},
			plugins: {
				message: new FormValidation.plugins.Message({
					container: (field, element) => element.closest('.mod-input,.checkbox'),
				}),
				declarative: new FormValidation.plugins.Declarative({
					html5Input: true,
				}),
				trigger: new FormValidation.plugins.Trigger(),
				submitButton: new FormValidation.plugins.SubmitButton(),
			},
		})
			.on('core.element.validated', (e) => {
				// e.element presents the field element
				// e.valid indicates the field is valid or not

				// Get the field value
				const value = fv.getElementValue(e.field, e.element);
				const container = FormValidation.utils.closest(e.element, '.mod-input,.checkbox');
				if (value === '') {
					FormValidation.utils.classSet(container, {
						'is-validation-failed': true,
					});
				} else {
					FormValidation.utils.classSet(container, {
						'is-validation-failed': false,
					});
				}

				if (!e.valid) {
					FormValidation.utils.classSet(container, {
						'is-validation-failed': true,
					});
				} else {
					FormValidation.utils.classSet(container, {
						'is-validation-failed': false,
					});
				}
			})
			.on('core.form.valid', () => {
				const formData = {};
				loginForm.querySelectorAll('input, textarea').forEach((input) => {
					if (input.type === 'checkbox') {
						formData[input.name] = input.checked;
					} else {
						formData[input.name] = input.value.trim();
					}
				});
				document.querySelector('body').classList.add('is-loading');
				axiosLoginAction(formData);
			});
	}
});
